import { useEffect, useState } from 'react';
import { clearRecordDraft, getRecordDraft, RECORD_DRAFT_EVENT } from '../utils/recordDraft';
import { SPORTS } from '../data/sports';

export default function DraftResumePrompt({ onResume, showToast }) {
    const [draft, setDraft] = useState(() => getRecordDraft());

    useEffect(() => {
        const sync = () => setDraft(getRecordDraft());
        window.addEventListener(RECORD_DRAFT_EVENT, sync);
        window.addEventListener('storage', sync);
        return () => {
            window.removeEventListener(RECORD_DRAFT_EVENT, sync);
            window.removeEventListener('storage', sync);
        };
    }, []);

    if (!draft) return null;

    const sportName = SPORTS[draft.form?.sport]?.name || '운동';
    const deleteDraft = () => {
        if (!window.confirm('정말 지울까요? 삭제된 임시 저장본은 되돌릴 수 없어요')) return;
        clearRecordDraft();
        showToast?.('임시 저장을 삭제했어요');
    };

    return (
        <div className="draft-resume-floating">
            <div className="draft-resume-copy">
                <strong>기록중이던 운동이 있어요.</strong>
                <span>{sportName} 기록을 이어서 작성할까요?</span>
            </div>
            <div className="draft-resume-actions">
                <button className="draft-resume-primary" onClick={onResume}>이어서 작성하기</button>
                <button className="draft-resume-delete" onClick={deleteDraft}>임시 저장 삭제</button>
            </div>
        </div>
    );
}
